import React from "react";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router";

import Link from "theme/components/atoms/Typography/Link";
import Button from "theme/components/atoms/Button";
import FormActions from "theme/components/molecules/Form/FormActions";
import LabelledIcon from "theme/components/molecules/LabelledIcon";

const returnToLastVisited = (hidePopin, history) => {
  hidePopin();
  return history.push(localStorage.getItem("last_category_visited"));
};
const ProductAddedPopInActions = ({ hidePopin, history }) => {
  return (
    <FormActions appearance="center">
      <Button
        onClick={() =>
          typeof window !== "undefined" &&
          localStorage &&
          localStorage.getItem("last_category_visited")
            ? returnToLastVisited(hidePopin, history)
            : hidePopin
        }
      >
        <LabelledIcon icon="chevron-left" size="tiny">
          <FormattedMessage
            id="modules.ProductAddedPopIn.continue"
            defaultMessage="Continue shopping"
          />
        </LabelledIcon>
      </Button>
      <Link to="/cart" buttonAppearance="primary">
        <LabelledIcon icon="cart" size="tiny" inverted>
          <FormattedMessage
            id="modules.ProductAddedPopIn.seeCart"
            defaultMessage="Go to cart"
          />
        </LabelledIcon>
      </Link>
    </FormActions>
  );
};

export default withRouter(ProductAddedPopInActions);
